<ui-web-banner class="conatiner-fluid"></ui-web-banner>

<ui-web-drc class="container-fluid ui-web-drc section-1"></ui-web-drc>

<ui-web-home-schedule class="container-fluid ui-web-home-schedule"></ui-web-home-schedule>

<div class="container-fluid ui-web-events__home">
    <div class="container">
        <h2>Upcoming Events</h2>
        <ui-web-events [showPageTitle]="false" [showAllEvents]="false" class="ui-web-events row"></ui-web-events>
        <div class="more-button">
            <button class="drc-btn btn-primary" (click)="onClickAllEvents()">All Events/Retreats <span class="icon-arrow-right"></span></button>
        </div>
    </div>
</div>

<div class="container-fluid ui-web-testimonies__home">
    <div class="container">
        <h2>Testimonies</h2>
        <ui-web-testimonies [showPageTitle]="false" [showAllTestimonies]="false"  class="ui-web-events row"></ui-web-testimonies>
        <div class="more-button">
            <button class="drc-btn btn-primary" (click)="onClickMoreTestimonies()">More Testimonies <span class="icon-arrow-right"></span></button>
        </div>
    </div>
</div>

<div class="container-fluid ui-web-ministries__home">
    <div class="container">
        <h2>Ministries</h2>
        <ui-web-ministries [showPageTitle]="false" class="row"></ui-web-ministries>
    </div>
</div>